var render = function render(_c,_vm){return _c('rate-types-info',{staticClass:"py-3",attrs:{"rates":_vm.props.row.rate_types}})
}
var staticRenderFns = []

export { render, staticRenderFns }